export default "/assets/images/rejoice-video.135f19a62a247b2c.mp4";